import * as React from 'react';
import { Icon } from '../Icon/icon';
import { getIdFriendlyName } from '../../utils/guid';
import { Tooltip } from '../Tooltip/Tooltip';
import { EditableInfoBubble } from '../../commonTypes/infobubble.types';

function shouldShowInfoBubble(bubble: EditableInfoBubble) {
  return bubble && (bubble.text || bubble.isInEditMode);
}

export const FileupLoadHeader: React.SFC<{
  heading: string;
  inputId: string;
  upload: string;
  mandatory?: boolean;
  controls: string;
  infoBubble?: EditableInfoBubble;
  mandatoryString?: string;
  checkMarkHeaderText?: string;
  allowedFileTypesText?: string;
}> = (props) => (
  <div className={`fileupload__header ${props.allowedFileTypesText ? 'fileupload__header--wrap' : ''}`}>
    <div
      id={getIdFriendlyName(props.heading, 'header')}
      className={`fileupload__heading ${
        shouldShowInfoBubble(props.infoBubble) ? 'fileupload__heading--infobubble' : ''
      }`}>
      {props.heading +
        (props.mandatory
          ? props.mandatoryString !== undefined
            ? ' ' + props.mandatoryString
            : ' (obligatoriskt)'
          : '')}

      {shouldShowInfoBubble(props.infoBubble) && (
        <Tooltip
          text={props.infoBubble.text}
          editableEpiserverPropertyName={props.infoBubble.propertyName}
          enableEpiserverOnPageEditing={true}
          isInEditMode={props.infoBubble.isInEditMode}
        />
      )}

      {props.checkMarkHeaderText && <div className="fileupload__header__leg-upload">{props.checkMarkHeaderText}</div>}
    </div>
    <button
      onClick={(_) => document.getElementById(props.inputId).click()}
      className="stripped-button fileupload__label"
      type="button"
      aria-controls={props.controls}
      aria-describedby={getIdFriendlyName(props.heading, 'header')}>
      <Icon className={'fileupload__svg'} iconType={'paper-clip'} />
      {props.upload}
    </button>
    {props.allowedFileTypesText && <span className="fileupload__allowed-formats">{props.allowedFileTypesText}</span>}
  </div>
);
